import { render, staticRenderFns } from "./StrainMetrcDetails.template.vue?vue&type=template&id=2b7cf8aa&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports